import React, { Component, useState } from "react"
import Layout from "../components/layout"
import { GatsbyImage } from "gatsby-plugin-image"
import { graphql, Link, useStaticQuery } from "gatsby"

import * as styles from "./field.module.css"
import Accordion from "@material-ui/core/Accordion"
import AccordionSummary from "@material-ui/core/AccordionSummary"
import AccordionDetails from "@material-ui/core/AccordionDetails"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import NestedAccordion from "../components/NestedAccordion"
import TestimonialSwiper2 from "../components/TestimonialSwiper2"

export default function Field({ pageContext }) {
  const {
    coverimage,
    name,
    faq,
    testimonials,
    faq_color,
    subfields,
    subfields_color,
    superfield,
  } = pageContext

  return (
    <Layout>
      <div className={styles.landing}>
        <GatsbyImage
          image={coverimage.childImageSharp.gatsbyImageData}
          className={styles.landingImage}
        />
      </div>
      {subfields.length > 0 && (
        <div className={styles.subfieldsWrapper}>
          <h2 className={styles.subfieldHeading}>Choose your subject</h2>
          <div className={styles.subfieldsGrid}>
            {subfields.map(field => (
              <Link
                to={`/${name}/${field.name}`}
                className={styles.subfieldsLink}
                style={{ textDecoration: "none" }}
              >
                <div
                  className={styles.subfield}
                  style={{
                    backgroundColor: subfields_color,
                    textDecoration: "none !important",
                  }}
                >
                  {field.name}
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
      {testimonials.length > 0 ? (
        <div>
          <div className={styles.testimonialsContainer}>
            <TestimonialSwiper2 data={testimonials} />
          </div>
          <div className={styles.faqContainer}>
            {faq.length > 0 && <FAQ data={faq} color={faq_color} />}
          </div>
        </div>
      ) : (
        <h1 className={styles.comingsoon}>COMING SOON. STAY TUNED.</h1>
      )}
    </Layout>
  )
}

const FAQ = ({ data, color }) => (
  <div
    className={styles.faqAccordionContainer}
    style={{ backgroundColor: color }}
  >
    <h1>QnA</h1>
    {data.map(item => (
      <div className={styles.faqAccordion}>
        <Accordion
          style={{
            backgroundColor: "transparent",
            border: "none",
            boxShadow: "none",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            style={{ borderBottom: "0.5px solid black" }}
          >
            <h3>{item.question}</h3>
          </AccordionSummary>
          <AccordionDetails style={{ display: "flex", flexFlow: "column" }}>
            {item.answer.length > 1 ? (
              item.answer.map(answerItem => {
                const words = answerItem.answer_body.split(" ")
                const read_more = []
                for (let i = 0; i <= 4; i++) {
                  read_more.push(words[i])
                }
                const testimonialLink =
                  answerItem.testimonial.id[0] === "T"
                    ? `/testimonial/${answerItem.testimonial.id.substr(12)}`
                    : `/testimonial/${answerItem.testimonial.id}`
                const summaryString = read_more.join(" ")

                return (
                  <NestedAccordion
                    answerItem={answerItem}
                    summaryString={summaryString}
                    testimonialLink={testimonialLink}
                  />
                )
              })
            ) : (
              <p style={{ lineHeight: "200%" }}>
                {item.answer[0].testimonial ? (
                  <span>
                    <b>{item.answer[0].testimonial.name}</b>:{" "}
                  </span>
                ) : (
                  <></>
                )}
                {item.answer[0].answer_body}
                {item.answer[0].testimonial ? (
                  <p style={{ fontSize: "0.9rem" }}>
                    {" "}
                    Read about {item.answer[0].testimonial.name}
                    's journey{" "}
                    <Link
                      to={
                        item.answer[0].testimonial.id[0] === "T"
                          ? `/testimonial/${item.answer[0].testimonial.id.substr(
                              12
                            )}`
                          : `/testimonial/${item.answer[0].testimonial.id}`
                      }
                      style={{ textDecoration: "underline" }}
                    >
                      here
                    </Link>{" "}
                  </p>
                ) : (
                  <></>
                )}
              </p>
            )}
          </AccordionDetails>
        </Accordion>
      </div>
    ))}
  </div>
)
